import React from 'react';

function StatusIndicator({ status }) {
  return (
    <div className={`status-indicator ${status.connected ? 'connected' : 'disconnected'}`}>
      <div className="status-dot"></div>
      <div className="status-text">
        <strong>Ollama Status:</strong>
        <span>{status.connected ? 'Connected' : 'Disconnected'}</span>
      </div>
      {status.connected && status.models && (
        <div className="status-details">
          {status.models.length} model(s) available
        </div>
      )}
      {!status.connected && (
        <div className="status-warning">
          Make sure Ollama is running at {status.base_url}
        </div>
      )}
    </div>
  );
}

export default StatusIndicator;
